import { Select, Spin } from "antd";
import React, { useCallback, useState } from "react";
import { apiContract } from "../../../../api/api-contract";

const { Option } = Select;

const SoHopDong = ({ setFieldsValue, name }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const onSearch = (value) => {
    setLoading(true);
    apiContract
      .contractCodeSuggest(value, 1, true)
      .then((res) => {
        if (res.status === "success") {
          setOptions(res.data.content.map((i) => ({ value: i.code })));
        }
      })
      .finally(() => setLoading(false));
  };

  const onChange = useCallback(
    (values) => {
      !!setFieldsValue &&
        setFieldsValue({ [name]: values.map((i) => i.value) });
    },
    [setFieldsValue]
  );

  return (
    <Select
      mode="multiple"
      showArrow
      placeholder="Số hợp đồng"
      labelInValue
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onChange={onChange}
      onSearch={onSearch}
    >
      {options.map((item, index) => (
        <Option key={index} value={item.value}>
          {item.value}
        </Option>
      ))}
    </Select>
  );
};

export default SoHopDong;
